const resources = {
    forYou: 'For You'
};

module.exports = function getResource(label) {
    return resources[label];
};
